import React, { ForwardedRef } from "react";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import S from "./Container.module.scss";

interface DA_ContainerProps {
    children: React.ReactNode;
    noVerticalPadding?: boolean;
    noRightPadding?: boolean;
    noLeftPadding?: boolean;
    noTopPadding?: boolean;
    noBottomPadding?: boolean;
    flexColumn?: boolean;
    keepNestedPadding?: boolean;
    noOverflow?: boolean;
    className?: string;
}

export const DA_Container = React.forwardRef(
    (
        {
            children,
            noVerticalPadding,
            noRightPadding,
            noLeftPadding,
            noTopPadding,
            noBottomPadding,
            flexColumn,
            keepNestedPadding,
            noOverflow,
            className,
        }: DA_ContainerProps,
        ref: ForwardedRef<HTMLDivElement>
    ): JSX.Element => (
        <div
            className={cn(
                S.container,
                noVerticalPadding && S.noVerticalPadding,
                noRightPadding && S.noRightPadding,
                noLeftPadding && S.noLeftPadding,
                noTopPadding && S.noTopPadding,
                noBottomPadding && S.noBottomPadding,
                flexColumn && S.flexColumn,
                // eslint-disable-next-line css-modules/no-undef-class
                keepNestedPadding && S.keepNestedPadding,
                noOverflow && S.noOverflow,
                className
            )}
            ref={ref}
        >
            {children}
        </div>
    )
);

DA_Container.displayName = "DA_Container";
